module.exports = __webpack_public_path__ + "static/media/arab19.c1d29e57.wav";